"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _mapProductDataNew = _interopRequireDefault(require("@deosite/helpers/mapProductDataNew"));
var _agent = require("@deosite/agent");
var _createSearchUrl = require("@deosite/helpers/createSearchUrl");
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(collectionId) {
    var pageSize,
      language,
      productsFromCollectionMapped,
      productsFromCollection,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageSize = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10;
            language = _args.length > 2 ? _args[2] : undefined;
            productsFromCollectionMapped = [];
            if (collectionId) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", productsFromCollectionMapped);
          case 5:
            _context.prev = 5;
            _context.next = 8;
            return _agent.requests.get((0, _createSearchUrl.createSearchUrl)("/products", [{
              field: "dajar_collection",
              condition_type: "eq",
              value: collectionId,
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "type_id",
              value: "simple",
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "visibility",
              condition_type: "in",
              value: [2, 4],
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              pageSize: pageSize
            }]), global.__appConfig__.elasticEnabled, null, language);
          case 8:
            productsFromCollection = _context.sent;
            if (productsFromCollection.total_count > 0) {
              productsFromCollectionMapped = (0, _mapProductDataNew["default"])(productsFromCollection.items);
            } else {
              productsFromCollectionMapped = [];
            }
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](5);
            console.log("There was an error while fetching products from collection ".concat(collectionId));
            productsFromCollectionMapped = [];
          case 16:
            return _context.abrupt("return", productsFromCollectionMapped);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 12]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;